module.exports = __webpack_public_path__ + "img/xz_public.a70bc614.png";